import {Link} from 'react-router-dom';
import {CustomMenu} from '../../../menus/custom-menu';

export function AuthLayoutFooter() {
  return (
    <div className="auth-footer">
      <Link to="/">
        &copy; Landed
      </Link>
      <CustomMenu
        menu="auth-page-footer"
        orientation="horizontal"
        itemClassName="hover:text-fg-base transition-colors"
      />
    </div>
  );
}
